import React from "react";
import {Link} from "react-router-dom";
import {priceConvert} from "../../units";
import {CoursesData} from "../types";

type Popular = Array<CoursesData>

const CourseItem:React.FC<{ lists:Popular,render?:Function }> = (props) => {
    const render = props.render
    return <React.Fragment>
        {
            props.lists.map((item,index:number) => {
                return <Link to={`/course/${item.courseId || item.id}/detail`} className="ke d" key={index}>
                    <div className="img-box">
                        <div className="img-bg" style={{ backgroundImage:`url(${ item.coverUrl })` }}/>
                        {/*<img src={ item.coverUrl } alt=""/>*/}
                    </div>
                    <div className="text">
                        <p className="solid">{ item.buyerQuantity }人买过</p>
                        <h3 className="u">{ item.courseName }</h3>
                        <p className='s'>{ item.courseSummary }</p>
                        <div className="b">
                            {
                                render && render(item)
                            }
                        </div>
                    </div>
                </Link>
            })
        }
    </React.Fragment>
}

export default CourseItem
